import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57625dea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Crea nuova timbratura", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Timbratura", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "date text-input pb-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "end-date" }, "Data timbratura", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_8 = {
  key: 0,
  class: "user text-input grid select pb-8"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "pb-1",
  for: "user"
}, "Dipendente", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_12 = {
  key: 1,
  class: "working-site text-input grid select pb-8"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "pb-1",
  for: "working-site"
}, "Cantiere", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_16 = { class: "type text-input grid select pb-8" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "pb-1",
  for: "type"
}, "Tipologia timbratura", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "in" }, "Timbratura in ingresso", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "out" }, "Timbratura in uscita", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "travelling" }, "Timbratura in viaggio", -1))
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_23 = {
  key: 2,
  class: "working-site text-input grid select pb-8"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "pb-1",
  for: "timing"
}, "Ore viaggio", -1))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 0,
  class: "font-light text-red-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalDialog, null, {
      h1: _withCtx(() => [
        _hoisted_1
      ]),
      h3: _withCtx(() => [
        _hoisted_2
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_PrimaryButton, {
          class: "button bg-white text-primary-900 undo",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Annulla")
          ]),
          _: 1
        }),
        _createVNode(_component_PrimaryButton, {
          class: "button bg-primary-900 text-white",
          onClick: _ctx.onCreate
        }, {
          default: _withCtx(() => [
            _createTextVNode("Crea")
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              message: "Salvataggio..."
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_DatePicker, {
              mode: "dateTime",
              "input-debounce": 500,
              is24hr: true,
              modelValue: _ctx.time,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.time) = $event))
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createElementVNode("input", _mergeProps({
                  class: ["bg-primary-50 border-red-400", { border: _ctx.v$.time.$error }],
                  id: "start-date",
                  type: "text",
                  placeholder: "GG/MM/AAAA HH:mm",
                  value: inputValue,
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.time.$touch && _ctx.v$.time.$touch(...args)))
                }, _toHandlers(inputEvents, true)), null, 16, _hoisted_6)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.time.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "errors",
                key: error.$uid
              }, [
                (error.$validator == 'required')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_7, "È necessario inserire la data e orario di timbratura"))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (_ctx.scope == _ctx.ClockingInScope.workingSite)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["input bg-primary-50 border-red-400", { border: _ctx.v$.userId.$error }]),
                  id: "user",
                  name: "user",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userId) = $event)),
                  onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.userId.$touch && _ctx.v$.userId.$touch(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: user.id
                    }, _toDisplayString(user.name) + " " + _toDisplayString(user.surname), 9, _hoisted_10))
                  }), 256))
                ], 34), [
                  [_vModelSelect, _ctx.userId]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.userId.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_11, "È necessario specificare l'utente"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.scope == _ctx.ClockingInScope.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["input bg-primary-50 border-red-400", { border: _ctx.v$.workingSiteId.$error }]),
                  id: "working-site",
                  name: "working-site",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.workingSiteId) = $event)),
                  onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.v$.workingSiteId.$touch && _ctx.v$.workingSiteId.$touch(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workingSites, (workingSite) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: workingSite.id
                    }, _toDisplayString(workingSite.name), 9, _hoisted_14))
                  }), 256))
                ], 34), [
                  [_vModelSelect, _ctx.workingSiteId]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.workingSiteId.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_15, "È necessario specificare il cantiere"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["input bg-primary-50 border-red-400", { border: _ctx.v$.clockingInType.$error }]),
              id: "type",
              name: "type",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.clockingInType) = $event)),
              onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.clockingInType.$touch && _ctx.v$.clockingInType.$touch(...args)))
            }, _hoisted_21, 34), [
              [_vModelSelect, _ctx.clockingInType]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.clockingInType.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "errors",
                key: error.$uid
              }, [
                (error.$validator == 'required')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_22, "È necessario specificare il tipo di timbratura"))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (_ctx.clockingInType == 'travelling')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["input bg-primary-50 border-red-400", { border: _ctx.v$.timing.$error }]),
                  id: "timing",
                  name: "timing",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.timing) = $event)),
                  disabled: _ctx.workingSiteId == undefined,
                  onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.timing.$touch && _ctx.v$.timing.$touch(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timings, (timing) => {
                    return (_openBlock(), _createElementBlock("option", { value: timing }, _toDisplayString(_ctx.humanizedClockingInTiming(timing)), 9, _hoisted_26))
                  }), 256))
                ], 42, _hoisted_25), [
                  [_vModelSelect, _ctx.timing]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.timing.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_27, "È necessario specificare le ore di viaggio"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Salvataggio..."
        }))
      : _createCommentVNode("", true)
  ], 64))
}